import MapKazakhstanSrc from './maps/kazakhstan.svg'
import MapKyrgyzstanSrc from './maps/kyrgyzstan.svg'
import MapTajikistanSrc from './maps/tajikistan.svg'
import MapTurkmenistanSrc from './maps/turkmenistan.svg'
import MapUzbekistanSrc from './maps/uzbekistan.svg'

export const data = [
  {
    mapSrc: MapKazakhstanSrc,
    countryName: 'Казахстан',
    description: (
      <>
        В 2024 году после резонансного убийства Салтанат Нукеновой в Уголовный
        кодекс Республики Казахстан внесли изменения, криминализировавшие легкий
        и средний вред здоровью, причиненный в результате насилия в семье. Эти
        поправки назвали "Законом Салтанат". Однако правозащитники говорят, что
        комплексного подхода к решению проблемы пока нет, а отсутствие единого
        закона против семейно-бытового насилия лишь усугубляет ситуацию.
      </>
    ),
  },
  {
    mapSrc: MapUzbekistanSrc,
    countryName: 'Узбекистан',
    description: (
      <>
        В апреле 2023-го в стране приняли закон, который ввел уголовную
        ответственность за насилие в семье. Однако правозащитная организация
        Amnesty International{' '}
        <a
          href="https://eurasia.amnesty.org/2023/04/06/parlament-uzbekistana-prinyal-davno-nazrevshij-zakon-ob-ugolovnoj-otvetstvennosti-za-nasilie-v-seme/?utm_source=chatgpt.com"
          target="_blank"
          rel="noreferrer"
        >
          отмечает
        </a>
        , что экономическое и психологическое насилие все еще недостаточно
        учитывается в законодательстве.
      </>
    ),
  },
  {
    mapSrc: MapKyrgyzstanSrc,
    countryName: 'Кыргызстан',
    description: (
      <>
        В 2017 году в стране приняли закон "Об охране и защите от семейного
        насилия", по которому ввели понятие охранного ордера. В 2024 году, после
        резонансного случая с истязанием Асель Ногойбаевой, парламент принял
        поправки, по которым увеличили срок охранного ордера с 3 до 30 дней, а
        также обязали агрессоров проходить коррекционную программу.
      </>
    ),
  },
  {
    mapSrc: MapTajikistanSrc,
    countryName: 'Таджикистан',
    description: (
      <>
        В стране с 2013 года{' '}
        <a
          href="https://paperlab.kz/borba-s-nasiliem-v-otnoshenii-zhenshchin"
          target="_blank"
          rel="noreferrer"
        >
          действует закон
        </a>{' '}
        "О предупреждении насилия в семье", который предполагает выдачу
        защитного предписания насильнику при первом обращении в полицию. Однако
        закон не классифицирует домашнее насилие как преступление, и более 80%
        нарушителей продолжают свои действия, игнорируя защитные меры, без
        каких-либо последствий.
      </>
    ),
  },
  {
    mapSrc: MapTurkmenistanSrc,
    countryName: 'Туркменистан',
    description: (
      <>
        специальных законов, которые криминализируют домашнее насилие, нет. В
        2015 году в стране был{' '}
        <a
          href="https://turkmenistan.gov.tm/ru/post/24857/zakon-turkmenistana-%3Cbr%3Eo-gosudarstvennykh-garantiyakh-obespecheniya-ravnykh-prav-i-ravnykh-vozmozhnostei-zhenschin-i-muzhchinhttps://turkmenistan.gov.tm/ru/post/24857/zakon-turkmenistana-%3Cbr%3Eo-gosudarstvennykh-garantiyakh-obespecheniya-ravnykh-prav-i-ravnykh-vozmozhnostei-zhenschin-i-muzhchin"
          target="_blank"
          rel="noreferrer"
        >
          принят закон
        </a>{' '}
        "О государственных гарантиях обеспечения равных прав и равных
        возможностей женщин и мужчин", где упоминается защита от насилия в
        семье, но без четких механизмов его применения – поэтому он{' '}
        <a
          href="https://rus.azathabar.com/a/semeynoe-nasilie-i-aborty-v-zheneve-obsudili-narushenie-prav-zhenschin-v-turkmenistane/32801033.html"
          target="_blank"
          rel="noreferrer"
        >
          плохо работает на практике
        </a>
        .
      </>
    ),
  },
]
